<script setup lang="ts">
import type { AudioBlock } from '../../../model/assessments/interfaces'
import type { ContentBlockOwner } from '../../../model/assessments/store/interfaces'

import { useContentBlockAudio } from '../../../model/assessments/content-block-editors.hook'
import AudioUploader from './AudioUploader.vue'

defineOptions({
  name: 'ContentBlockAudio',
})

const props = defineProps<{
  owner: ContentBlockOwner
  index: number
  block: AudioBlock
}>()

const {
  setUrl,
} = useContentBlockAudio({
  owner: () => props.owner,
  index: () => props.index,
})
</script>

<template>
  <div class="content-block-audio">
    <!-- `asset.url` holds either an uploaded object path or an external URL; the uploader owns
         that distinction, and this block only forwards whichever string comes back. -->
    <AudioUploader
      :value="block.asset.url"
      @update:value="setUrl"
    />
  </div>
</template>

<style scoped lang="scss" src="./ContentBlockAudio.scss" />
